module.exports = __webpack_public_path__ + "static/media/c2.93179a0d.png";